import Settings from 'modules/user-management/settings';

export default function SettingsPage() {
  return <Settings />;
}
